<!-- 加载编辑器的容器 -->
<div [id]="config.name" #editerDom> </div>
